import React, { useState, useEffect } from 'react'
import { DashboardLayout, MultiFilters, GeneralTable, Toaster, SubmenuTooltip, MoreButton } from 'components'
import { useCustomSelector } from 'hooks';
import { isObjectEmpty, isArrayNotEmpty, getTotalCountFromHeader } from 'functions';
import { debitNoteColumns } from './hooks/debitNoteColumns';
import useDebitNoteV2 from 'dataflow/billingPortal/actions/useDebitNoteV2.actions';
import ic_delete from 'assets/images/ic_delete_invoices.svg';
import { useDeleteDebitNote } from './hooks/useDeleteDebitNote';
import { subsidiaryList } from 'constants/lists';

function DebitNoteV2() {

    const [selectedDebitNotes, setSelectedDebitNotes] = useState([]);

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");
    
    let { 
        getDebitNoteList_requesting, debitNoteListList, debitNoteListListHeaders, deleteDebitNote_isSuccessful
    } = useCustomSelector("debitNoteV2");

    const { getDebitNoteList } = useDebitNoteV2();

    const {
        setIsModalVisible: setIsDeleteModalVisible,
        deleteModalDisplay
    } = useDeleteDebitNote({
        selectedDebitNotes
    });

    useEffect(() => {
        if(deleteDebitNote_isSuccessful) {
            setIsDeleteModalVisible(false);
            setSelectedDebitNotes([]);
        }
    }, [deleteDebitNote_isSuccessful])

    return (
        <DashboardLayout
            headerTitle={"Debit Note"}

            bodyClassName={"debit-note__body"}
            body={(
                <GeneralTable
                    className={"body__table"}
                    columns={debitNoteColumns.getColumns()}
                    data={userPermissions?.Internal_DebitNote_View? debitNoteListList: []}

                    getTableData={getDebitNoteList}
                    onRowSelectionChange={setSelectedDebitNotes}

                    outerTableHeader={() => {
                        return (
                            <div className={"table__header d-flex align-items-center justify-content-between "}>

                                {/* Delete modal */}
                                {deleteModalDisplay}

                                <div className={"header__title tableHeaderTitle "}>
                                    List
                                </div>
                            
                                <SubmenuTooltip
                                    menuItems={[
                                        {
                                            icon: ic_delete,
                                            label: "Delete",
                                            isDisabled: (!userPermissions?.Internal_AdvancePay_Delete),
                                            onClick: () => {
                                                if (isArrayNotEmpty(selectedDebitNotes)) {
                                                    setIsDeleteModalVisible(true);
                                                }
                                                else {
                                                    Toaster({
                                                        type: "info",
                                                        msg: "Please select at least 1 debit note.",
                                                    });
                                                }
                                            },
                                        }
                                    ]}
                                >
                                    <MoreButton
                                        className={"action__more-actions"}
                                        iconClassName={"more-actions__icon"}
                                    />
                                </SubmenuTooltip>
                            </div>
                        );
                    }}

                    bottomOuterTableHeader={(outerTableHeader_props) => {
                        const {
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__table-filter d-flex flex-wrap align-items-center"}>
                                <MultiFilters
                                    defaultFilterOption={{
                                        label: "COM ID", 
                                        propertyName: "comId",
                                        placeholder: "COM ID",
                                        inputType: "search",
                                        isInputDigitOnly: true
                                    }}
                                    filterOptions={[
                                        {
                                            label: "COM ID", 
                                            propertyName: "comId",
                                            placeholder: "COM ID",
                                            inputType: "search",
                                            isInputDigitOnly: true
                                        },
                                        {
                                            label: "Account Code", 
                                            propertyName: "accountCode",
                                            placeholder: "Account Code",
                                            inputType: "search"
                                        },
                                        {
                                            label: "Product Code", 
                                            propertyName: "productCode",
                                            placeholder: "Product Code",
                                            inputType: "search"
                                        },
                                        {
                                            label: "Reference Document No", 
                                            propertyName: "documentNo",
                                            placeholder: "Reference Document No",
                                            inputType: "search"
                                        },
                                        {
                                            label: "Charge Month", 
                                            propertyName_start: "filterFrom",
                                            propertyName_end: "filterTo",
                                            placeholder_start: "Start",
                                            placeholder_end: "End",
                                            inputType: "dateRange"
                                        },
                                        {
                                            label: "Plan Number", 
                                            propertyName: "planNo",
                                            placeholder: "Plan Number",
                                            inputType: "search",
                                        },
                                        {
                                            label: "Subsidiary", 
                                            propertyName: "subsidiary",
                                            placeholder: "Subsidiary",
                                            options: [{ label: "All", value: "" }].concat(subsidiaryList),
                                            inputType: "dropdown"
                                        }
                                    ]}
                                    dropdownPlaceholder={"Select Filter"}
                                    onApplyFilter={(inputFilters) => {
                                        setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                    }}
                                />
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={getDebitNoteList_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(debitNoteListListHeaders)}
                    isTableRefreshRequired={deleteDebitNote_isSuccessful}

                    isExpanderRequired isRowExpanderColumnFirst
                    isColumnResizeable
                    isTableOddRowsDarken
                    isCheckboxRequired
                    isCheckboxColumnFirst
                />
            )}
        />
    )
}

export default DebitNoteV2